import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-318d1562")
const _hoisted_1 = {
  key: 0,
  class: "sing-play"
}
const _hoisted_2 = {
  key: 1,
  class: "sing-play-not-render"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "教材曲谱加载中...", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "sing-play-not-render"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "教材曲谱渲染失败", -1)
const _hoisted_7 = [
  _hoisted_6
]
_popScopeId()

import _ from "lodash";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  watchEffect,
} from "vue";
import { ElMessage } from "element-plus";
import logger from "@evideo/logger";

import useUpLoad from "@/hooks/useUpLoad";
import useGlobalPencil from "@/hooks/useGlobalPencil";
import servers from "@/config/servers";
import config from "@/config/app.config";
import { eventCenter } from "@evideo/frontend-utils";

import SheetMusicSong from "@evideo/design-vue/lib/sheet-music-song";
import SingPlayConfirm from "./SingPlayConfirm.vue";

import "@evideo/design-vue/lib/sheet-music-song/style";

declare global {
  interface Window {
    SheetMusic: any;
    SheetMusicBusiness: any;
    SVG: any;
    Display: any;
    initSheetLib: any;
  }
}


export default _defineComponent({
  props: {
  data: {
    type: Object,
    required: true,
  },
},
  emits: ["goBack"],
  setup(__props, { emit: emits }) {

const props = __props

/**
 * 将对象转成小写头峰
 * @param obj
 * @param newObj
 * @returns
 */
const toCameCaseObj = (obj: Record<string, any>, newObj: any = {}) => {
  if (typeof obj !== "object") {
    return {};
  }

  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      const newArray: any[] = [];
      value.forEach(([, v]) => {
        newArray.push(toCameCaseObj(v));
      });
      newObj[_.camelCase(key)] = newArray;
    } else {
      if (typeof value === "object" && value !== null && value !== undefined) {
        newObj[_.camelCase(key)] = toCameCaseObj(value);
      } else {
        newObj[_.camelCase(key)] = value;
      }
    }
  });
  return newObj;
};
const singPlay = ref();
const singPlayData = ref<any>({});

const canRenderSingPlay = ref(false);
const loading = ref(true);

const recordConfirmVisible = ref(false);
const recordScoreData = ref<any>({});

const { upload } = useUpLoad();
const {
  pencilState,
  sendSvgHeight,
  handlePencilState,
  handleSingPlayScroll,
  CanvasScrollOn,
  handShowState,
  changeIsPlay,
} = useGlobalPencil();


const onSuccess = () => {
  // 判断是否在electron环境中
  if (window.require) {
    sendSvgHeight();
    addEventListenerPaperScroll();
    CanvasScrollOn();
    handShowState();
  }
};
const addEventListenerPaperScroll = () => {
  nextTick(() => {
    if (singPlay.value) {
      const paper = document.getElementById("paper")!;
      paper.addEventListener(
        "scroll",
        (event: any) => {
          pencilState.value &&
            handleSingPlayScroll(
              event.path[0].scrollTop,
              singPlay.value.playState === "start" ||
                singPlay.value.playState === "continue"
            );
        },
        { passive: false }
      );
    }
  });
};

const onError = (e: any) => {
  logger.warn(e);
  ElMessage.error({
    type: "error",
    message: "曲谱加载失败,请重新加载课件或检查网络",
    offset: 200,
  });
};

const onAudioCacheError = ({
  audioCanPlay,
  preFetchAudioOK,
}: {
  audioCanPlay: boolean;
  preFetchAudioOK: boolean;
}) => {
  if (!audioCanPlay) {
    ElMessage.error({
      type: "error",
      message: "音频加载失败,请重新加载课件或检查网络",
      offset: 200,
    });
    return;
  }
  if (!preFetchAudioOK) {
    ElMessage.error({
      type: "error",
      message: "音频正在加载，请稍后尝试",
      offset: 200,
    });
    return;
  }
};

const onUploadRecordScore = (file: any) => {
  recordScoreData.value = {};
  return new Promise((resolve) => {
    recordScoreData.value = file;
    recordConfirmVisible.value = true;
    resolve("");
  });
};
// 上传录音和eur文件至oss
const uploadRecordEurData = async () => {
  try {
    const recordBlob = await singPlay.value.handleMergeSound();
    const recordFile = new File([recordBlob], "record.mp3");
    const eurXmlBlob = new Blob([recordScoreData.value["eur_file_url"]]);
    const eurXmlFile = new File([eurXmlBlob], "eurXml.eur");
    const {
      url: fileUrl,
      md5: fileMd5,
      size: fileSize,
    } = await upload(recordFile);
    const {
      url: eurXmlFileUrl,
      md5: eurXmlFileMd5,
      size: eurXmlFileSize,
    } = await upload(eurXmlFile);
    recordScoreData.value["file_url"] = fileUrl;
    recordScoreData.value["file_md5"] = fileMd5;
    recordScoreData.value["file_size"] = fileSize;

    recordScoreData.value["eur_file_md5"] = eurXmlFileMd5;
    recordScoreData.value["eur_file_size"] = eurXmlFileSize;
    recordScoreData.value["eur_file_url"] = eurXmlFileUrl;
  } catch (e) {
    logger.error(`评分录音文件上传失败${e}`);
  }
};

/**
 * 上传录音
 */
const uploadRecording = (data: any) => {
  return new Promise<void>((resolve, reject) => {
    const token = localStorage.getItem("token");
    fetch(`${config[servers.device]}/teacher/records`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          resolve();
        } else {
          reject("");
        }
      })
      .catch((err) => {
        reject(err?.message);
      });
  });
};

// 录音评分上传事件
const handleUploadRecordScore = async (students?: any) => {
  singPlay.value.loadObj.loading = true;
  singPlay.value.loadObj.loadingTip = "上传中...";
  recordConfirmVisible.value = false;
  const timeId = setTimeout(() => {
    ElMessage.error({
      type: "error",
      message: "上传超时，请检查网络，重新上传",
      offset: 200,
    });
    singPlay.value.loadObj.loading = false;
    singPlay.value.loadObj.reset();
    return Promise.reject("上传超时");
  }, 300000);
  try {
    await uploadRecordEurData();
    await uploadRecording({ ...recordScoreData.value, ...students });
    timeId && clearTimeout(timeId);
    logger.info(`录音评分数据上传成功`);
    ElMessage.success({
      type: "success",
      message: "上传成功",
      offset: 200,
    });
  } catch (e) {
    timeId && clearTimeout(timeId);
    logger.error(`录音评分数据上传失败${(e as any)?.message}`);
    ElMessage.error({
      type: "error",
      message: "上传失败",
      offset: 200,
    });
  } finally {
    singPlay.value.loadObj.loading = false;
    singPlay.value.loadObj.reset();
  }
};

/**
 * 发送打开学生弹窗事件
 */
const registerStudentsModal = () => {
  return new Promise<any[]>((resolve) => {
    eventCenter.send("ppt-open-students-modal");
    eventCenter.sub("ppt-selected-students", (students: any[]) => {
      resolve(students);
    });
    eventCenter.sub("ppt-select-student-modal-close", () => {
      resolve([]);
    });
  });
};

// 录音评分关联学生上传事件
const handleUploadRelativeStudents = async () => {
  try {
    const students = (await registerStudentsModal()) || [];
    const selectedIds: number[] = [];
    students.forEach((item: any) => {
      selectedIds.push(item.id);
    });
    if (selectedIds.length) {
      await handleUploadRecordScore({
        relate_user_ids: selectedIds,
        relate_type: "student_sing",
      });
    }
    recordConfirmVisible.value = false;
  } catch (e) {
    logger.error(`录音评分数据关联学生上传失败${e}`);
  }
};

// const goBack = () => {
//   emits("goBack");
// };
watch(
  () => pencilState.value,
  (newVal) => {
    const scrollTop = document.getElementById("paper")!.scrollTop;

    newVal &&
      handleSingPlayScroll(
        scrollTop,
        singPlay.value.playState === "start" ||
          singPlay.value.playState === "continue",
        true
      );
  }
);
watchEffect(() => {
  if (singPlay.value) {
    const scrollTop = document.getElementById("paper")!.scrollTop;
    handleSingPlayScroll(
      scrollTop,
      singPlay.value.playState === "start" ||
        singPlay.value.playState === "continue"
    );
  }
});
watchEffect(() => {
  changeIsPlay(
    singPlay?.value?.playState === "start" ||
      singPlay?.value?.playState === "continue"
  );
});

const initSingPlayData = async () => {
  let data = props.data;
  if (props.data && props.data?.localJsonUrl) {
    const res = await fetch(props.data.localJsonUrl);
    data = await res.json();
  }
  data = toCameCaseObj(data || {});
  let loadSheetMode = "common";
  if (window.WebViewJavascriptBridge) {
    loadSheetMode = "svgStr";
  }

  // 默认播放模式为范唱，无音频则伴唱，无则曲谱模式
  let playMode = "ori";
  if (!data?.["oriFileUrl"]) {
    playMode = "acc";
  }
  if (playMode === "acc" && !data?.["accFileUrl"]) {
    playMode = "midi";
  }

  const entryUrl = config[servers.cloud];
  singPlayData.value = {
    playMode,
    song: data,
    loadSheetMode,
    playerOptions: {},
    svgApi: `${entryUrl}/sheet-svg/render-data`,
    enableGesture: !pencilState.value, // 画笔开起来 不应该有手势缩放
  };
};

onMounted(async () => {
  canRenderSingPlay.value = false;
  if (!(window.SVG && window.Display && window.SheetMusic?.Note)) {
    try {
      await window.initSheetLib();
    } catch (e) {
      console.error("initSheetLib error", e);
      loading.value = false;
      canRenderSingPlay.value = false;
      return;
    }
  }
  await initSingPlayData();
  loading.value = false;
  canRenderSingPlay.value = true;
  handlePencilState();
});

onBeforeUnmount(() => {
  // fixme: 关闭ppt，需要直接关闭画笔，无论有没有开启
  if (window.require) {
    const ipcRenderer = window.require("electron").ipcRenderer;
    ipcRenderer.sendToHost("closePencil", [false]);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (canRenderSingPlay.value && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(SheetMusicSong), _mergeProps({ ref: singPlay }, singPlayData.value, {
            onError: onError,
            onSuccess: onSuccess,
            onAudioCacheError: onAudioCacheError,
            onUploadRecordScore: onUploadRecordScore
          }), null, 16)
        ]))
      : (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
    (recordConfirmVisible.value)
      ? (_openBlock(), _createBlock(SingPlayConfirm, {
          key: 3,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (recordConfirmVisible.value = false)),
          onOnOk: handleUploadRelativeStudents,
          onOnCancel: handleUploadRecordScore
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})